import Layout from '../Layout/index.vue'
const routes = [{
        name: 'Login',
        path: '/login',
        meta: {
            title: '登录'
        },
        component: () =>
            import ('../pages/Account/Login.vue'),
    },
    {
        path: '/',
        component: Layout,
        redirect: '/activity',
        children: [
            {
                path: 'index',
                name: 'Home',
                meta: {
                    title: '专辑',
                    contentScroll: true
                },
                component: () =>
                    import ('../pages/Dti/Album/list.vue'),
            },

            {
                path: 'dtiAlbum',
                name: 'dtiAlbum',
                meta: {
                    title: '专辑列表',
                },
                component: () => import ('../pages/Dti/Album/list.vue')
            },
            {
                path: 'dtiAlbum/create',
                name: 'dtiAlbumCreate',
                meta: {
                    title: '新增专辑'
                },
                component: () => import ('../pages/Dti/Album/create.vue')
            },
            {
                path: 'dtiAlbum/detail/:id',
                name: 'dtiAlbumDetail',
                meta: {
                    title: '专辑详情'
                },
                component: () => import ('../pages/Dti/Album/detail.vue')
            },
            {
                path: 'dtiAlbum/edit/:id',
                name: 'dtiAlbumEdit',
                meta: {
                    title: '编辑专辑',
                },
                component: () => import('../pages/Dti/Album/edit.vue')
            },
            {
                path: 'dtiUser',
                name: 'dtiUser',
                meta: {
                    title: '用户列表',
                },
                component: () => import ('../pages/Dti/User/list.vue')
            },
            {
                path: 'homeConfigure',
                name: 'homeConfigure',
                meta: {
                    title: '首页配置',
                },
                component: () => import ('../pages/Dti/Home/configure.vue')
            },
            {
                path: 'reportsList',
                name: 'reportsList',
                meta: {
                    title: '报告列表',
                },
                component: () => import ('../pages/Dti/Reports/list.vue')
            },
            {
                path: 'reportsList/detail/:id',
                name: 'reportsDetail',
                meta: {
                    title: '报告详情'
                },
                component: () => import ('../pages/Dti/Reports/detail.vue')
            },
            {
                path: 'reportsList/edit/:id?',
                name: 'reportsListEdit',
                meta: {
                    title: '报告编辑',
                },
                component: () => import('../pages/Dti/Reports/edit.vue')
            },
            {
                path: 'apply',
                name: 'Apply',
                meta: {
                    title: '报名列表',
                },
                component: () => import ('../pages/Dti/Apply/index.vue')
            },
            {
                path: 'activityDetail',
                name: 'ActivityDetail',
                meta: {
                    title: '报名列表',
                },
                component: () => import ('../pages/Dti/Apply/activityDetail.vue')
            },
            {
                path: 'dtiApply',
                name: 'dtiApply',
                meta: {
                    title: '报名列表',
                },
                component: () => import ('../pages/Dti/Apply/list.vue')
            },
            {
                path: 'innovaApply',
                name: 'InnovaApply',
                meta: {
                    title: '报名列表',
                },
                component: () => import ('../pages/Dti/Apply/innovationList.vue')
            },
            {
                path: 'innovaApply/detail/:id',
                name: 'InnovaDetail',
                meta: {
                    title: '报名详情',
                },
                component: () => import ('../pages/Dti/Apply/innovaDetail.vue')
            },
            {
                path: 'dtiApply/detail/:id',
                name: 'applyDetail',
                meta: {
                    title: '报告详情'
                },
                component: () => import ('../pages/Dti/Apply/detail.vue')
            },
            {
                path: 'drafts',
                name: 'drafts',
                meta: {
                    title: '草稿箱',
                },
                component: () => import('../pages/Dti/Reports/drafts.vue')
            },
            {
                path: 'activity',
                name: 'Activity',
                meta: {
                    title: '活动',
                },
                component: () => import('../pages/Dti/Activity/index.vue')
            },
            {
                path: 'activity/detail',
                name: 'ActivityDetail',
                meta: {
                    title: '报名详情',
                },
                component: () => import('../pages/Dti/Activity/detail.vue')
            },
            {
                path: 'activity/create',
                name: 'ActivityCreate',
                meta: {
                    title: '新增活动',
                },
                component: () => import('../pages/Dti/Activity/create.vue')
            },
            {
                path: 'form/createForm',
                name: 'CreateForm',
                meta: {
                    title: '创建表单',
                },
                component: () => import('../pages/Dti/Form/createForm.vue')
            },
            {
                path: 'form',
                name: 'Form',
                meta: {
                    title: '表单',
                },
                component: () => import('../pages/Dti/Form/index.vue')
            },
            {
                path: 'form/detail',
                name: 'FormDetail',
                meta: {
                    title: '报名详情',
                },
                component: () => import('../pages/Dti/Form/detail.vue')
            },
            {
                path: 'order',
                name: 'Order',
                meta: {
                    title: '表单',
                },
                component: () => import('../pages/Dti/Order/index.vue')
            },
           
        ]
    }
]
export default routes;
